import React, { useState, useEffect } from "react";
import ModalWrapper from "../../../Components/Modals/ModalWrapper";
import BalanceManagement from "./Components/BalanceManagement";
import ShipperDetails from "./Components/ShipperDetails";
import ResetPassword from "./Components/ResetPassword";
import Formula from "./Components/Formula";
import ChargeClientCard from "./Components/ChargeClientCard";
import Carriers from "./Components/Carriers";
import { useTranslation } from "react-i18next";

const AdminControls = ({ open, setOpen, shipperData, updateShipper }) => {
  const { t } = useTranslation("admin");
  const [activeTab, setActiveTab] = useState("shippers-details");
  const [localShipperData, setLocalShipperData] = useState(shipperData);

  // Sync when parent prop changes (e.g., when opening for a different shipper)
  useEffect(() => {
    setLocalShipperData(shipperData);
  }, [shipperData]);

  const tabs = [
    { id: "shippers-details", label: t("controls.shippersDetails") },
    { id: "carrier-management", label: t("controls.carriers") },
    { id: "charge-client-card", label: t("controls.chargeClientCard") },
    { id: "account-balance", label: t("controls.accountBalance") },
    { id: "formula", label: t("controls.markupBilling") },
    { id: "reset-password", label: t("controls.resetPassword") },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "carrier-management":
        return (
          <Carriers
            shipperData={localShipperData}
            updateShipper={updateShipper}
          />
        );

      case "shippers-details":
        return (
          <ShipperDetails
            shipperData={localShipperData}
            updateShipper={updateShipper}
          />
        );

      case "charge-client-card":
        return (
          <ChargeClientCard
            shipperData={localShipperData}
            updateShipper={updateShipper}
          />
        );

      case "account-balance":
        return (
          <BalanceManagement
            userData={{
              username: localShipperData.username,
              businessName: localShipperData.businessName,
            }}
            shipperData={localShipperData}
            updateShipper={updateShipper}
          />
        );

      case "formula":
        return (
          <Formula
            shipperData={localShipperData}
            updateShipper={updateShipper}
          />
        );

      case "reset-password":
        return <ResetPassword shipperData={shipperData} />;

      default:
        return null;
    }
  };

  return (
    <ModalWrapper
      isOpen={open}
      // onClose={() => setOpen(false)}
      boxClassName="!w-full !max-w-7xl max-h-[95vh] overflow-hidden p-0 m-2 !border-none"
      backdropClassName="bg-black bg-opacity-50"
    >
      <div className="bg-ui-surface rounded-lg w-full max-h-[95vh] overflow-hidden">
        <div className="bg-brand px-3 sm:px-4 md:px-6 py-3 md:py-4">
          <div className="flex items-center justify-between">
            <div className="w-8"></div>
            <h1 className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-white text-center flex-1 px-2">
              {t("controls.manageAccount", {
                name: localShipperData?.username,
                business: localShipperData?.business_name,
              })}
            </h1>
            <button
              onClick={() => setOpen(false)}
              className="text-white hover:text-ui-border transition-colors p-1"
              title={t("common:actions.close")}
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="bg-ui-surface border-b border-ui-border">
          <div className="flex justify-start sm:justify-center space-x-1 px-2 sm:px-4 md:px-6 overflow-x-auto scrollbar-hide">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`relative py-2 my-2 px-2 sm:px-3 md:px-4 lg:px-6 font-medium text-xs sm:text-sm transition-all duration-300 whitespace-nowrap rounded-tl-lg rounded-tr-lg flex-shrink-0
                ${
                  tab.status === "disabled"
                    ? "bg-ui-border text-ui-text-subtle cursor-not-allowed opacity-60"
                    : activeTab === tab.id
                    ? "bg-brand text-white font-semibold"
                    : "bg-ui-surface-sunken text-ui-text-muted hover:text-ui-text hover:bg-ui-border"
                }`}
                disabled={tab?.status === "disabled"}
              >
                <span className="hidden sm:inline">{tab.label}</span>
                <span className="sm:hidden">
                  {tab.label
                    .split(" ")
                    .map((word) => word[0])
                    .join("")}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="!p-2 sm:!p-3 md:!p-4 lg:!p-12 max-h-[calc(95vh-120px)] sm:max-h-[calc(95vh-140px)] overflow-y-auto">
          {renderTabContent()}
        </div>
      </div>
    </ModalWrapper>
  );
};

export default AdminControls;
